import { array } from "prop-types";
import "toastr/build/toastr.min.css";
import { toast } from "react-toastify";
import { CLIENT_SECTION } from "../config/apiEndPoint";
import { GET, POST, PUT } from "config/api.config";

export const getClientSectionList = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_SECTION.GET_CLIENT_LIST}/${data?._Id}`
      : `${CLIENT_SECTION.GET_CLIENT_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const addClientSection = async (data = array()) => {
  try {
    const response = await POST(CLIENT_SECTION.ADD_CLIENT, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const updateClientSection = async (id, data = array()) => {
  try {
    const url = `${CLIENT_SECTION.ADD_CLIENT}/${id}`;
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

/** PUT `Client/{clientId}/status` — update client active/deactive status. */
export const updateClientSectionStatus = async (clientId, data = array()) => {
  try {
    const url = CLIENT_SECTION.UPDATE_CLIENT_STATUS(clientId);
    const response = await PUT(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const getClientSectionDataById = async (data = array()) => {
  try {
    const url = data?.Id
      ? `${CLIENT_SECTION.GET_CLIENT_LIST}/${data?.Id}`
      : `${CLIENT_SECTION.GET_CLIENT_LIST}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const fetchClientSectionTableAndFilterSchema = async (data = array()) => {
  try {
    const url = data?._Id
      ? `${CLIENT_SECTION.GET_CLIENT_SCHEMA}/${data?._Id}`
      : `${CLIENT_SECTION.GET_CLIENT_SCHEMA}`;
    const response = await GET(url, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};

export const submitClientSectionFilterData = async (data = array()) => {
  try {
    const response = await POST(CLIENT_SECTION.SUBMIT_FILTER_DATA, data);
    return response;
  } catch (error) {
    toast.error(error?.message);
  }
};
